export default "__VITE_ASSET__BGamuZ$N__"